export default __webpack_public_path__ + "static/media/about.41e6379c.jpg";